export default __webpack_public_path__ + "static/media/OLI_Community_Logo.c6573605.png";